export class Toggle {
    constructor(lines, devices, savings, customerContact) {
        this.lines = lines;
        this.devices = devices;
        this.savings = savings;
        this.customerContact = customerContact;
    }
}